export default {
  PRE_AGREEMENT: 'PRE_AGREEMENT',
  AUCTION: 'AUCTION',
  TRANSACTION: 'TRANSACTION',
};
